module.exports = __webpack_public_path__ + "f335a4bf274844f674e96734b5adb77c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-emo.png
// module id = 2831
// module chunks = 0